export default "__VITE_ASSET__D$Bc$K3S__"